import React, { useState, useEffect } from 'react';
import convert from 'convert-units';
import Loadable from './loading/Loadable.js';

// The base unit is kg

import api from '../../api/index.js';

export default (props) => {
	const [units, setUnits] = useState(false);

	const refresh = async () => {
		setUnits(await api.settings.get('display_units_mass'));
	}

	useEffect(()=>{
		if (units === false)
			refresh();
	});


	let val = '';
	if (units !== false) {
		val = convert(parseFloat(String(props.value).trim())).from('kg').to(units);
		const precision = props.precision === null ? 2 : props.precision;
		const mult = Math.pow(10,precision);
		val = Math.round(val*mult)/mult;
	}

	let valstring = val.toLocaleString();
	if (valstring == 'NaN')
		valstring = props.nan || '?';

	return <Loadable ready={units !== false}>
			{valstring} {units}
		</Loadable>;
}
